import React from "react";
import "./Loading.css";
import {
  LoadingContainer,
  LoadingLogoWrapper,
  RotatingArc,
  CenterLogo,
  TextoCargando,
} from "./localstyle";
import Llama from "./assets/Llama.png";
import ObjNaranja from "./assets/ObjNaranja.png";
import { IonSpinner } from "@ionic/react";

const Loading = ({ dataLoading, color, descripcion }) => {
  let config = localStorage.getItem("config");
  let portal = JSON.parse(config).portal;

  return (
    <React.Fragment>
      {dataLoading &&
        (portal === "dim" ? (
          <LoadingContainer>
            <LoadingLogoWrapper $texto={descripcion}>
              <RotatingArc>
                <img src={ObjNaranja} alt="" />
              </RotatingArc>
              <CenterLogo src={Llama} alt="Logo" />
            </LoadingLogoWrapper>
            <TextoCargando className="rb18m">{descripcion}</TextoCargando>
          </LoadingContainer>
        ) : (
          <div className="ptur-fondo-loading">
            <span className={color}>
              <IonSpinner name="lines" />
            </span>
            <span className={`${color} rb18m`}>{descripcion}</span>
          </div>
        ))}
    </React.Fragment>
  );
};

export default Loading;
